
import "/app/apps/console/src/components/right-content/index.less?modules";
export default {"search": `search-qX8LqF80`,"account": `account-r9dvuQEt`,"avatar": `avatar-2RaajVRC`,"menu": `menu-YO6Drc_N`,"right": `right-GzkBI5mx`,"action": `action-s4Q7js6U`}
